import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import BackToTop from "components/common/BackToTop";
import Drawer from "components/common/Drawer";
import { useScreenSize } from "provider/ScreenSizeProvider";
import DailySightUpdate from "components/common/DailySightUpdate";

function MainLayout() {
  const location = useLocation();
  const { isMobileView } = useScreenSize();
  const pathSegments = location.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      {isMobileView && <Drawer />}
      <BackToTop />
      {/* <DailySightUpdate /> */}
      <ToastContainer
        position="top-center"
      />
    </>
  );
}

export default MainLayout;
